import React from "react";
import {
  MultiSelectList,
  IMultiSelectItem,
  QuestionTooltipProps,
} from "component-library";

import {
  IMembershipsViewModel,
  FacetViewModel,
  FacetCategoryViewModel,
} from "../../../../models/views";
import { ControlSection } from "../../../../../Common";

export interface IMembershipsContent {
  membershipsTooltip: QuestionTooltipProps;
  membershipsSectionName: string;
  membershipsField: string;
  membershipsPlaceholder: string;
}

interface IMembershipsProps {
  model: IMembershipsViewModel;
  content: IMembershipsContent;
  facet: FacetCategoryViewModel;
  handleChanges: (model: IMembershipsViewModel) => void;
}

interface IMembershipsState {
  selectedData: IMultiSelectItem<number>[];
  isDisabled: boolean;
}

export default class Memberships extends React.Component<
  IMembershipsProps,
  IMembershipsState
> {
  private membershipsFacet: IMultiSelectItem<number>[];
  private maxActiveCount: number;

  constructor(props: IMembershipsProps) {
    super(props);

    this.maxActiveCount = props.facet.maxActiveCount;
    this.membershipsFacet = this.mapFacetsToMultiSelectItems(
      props.facet.facets
    );

    this.state = {
      isDisabled: props.model.memberships.length >= this.maxActiveCount,
      selectedData: props.model.memberships.map((membership) => ({
        name: membership.name,
        value: membership.id,
      })),
    };
  }

  public render() {
    const { selectedData, isDisabled } = this.state;
    const { content } = this.props;

    return (
      <ControlSection name={content.membershipsSectionName}>
        <div className="c-basic-info-form__memberships">
          <MultiSelectList
            type="autocomplete"
            content={{
              label: content.membershipsField,
              tooltip: content.membershipsTooltip,
              placeholder: content.membershipsPlaceholder,
            }}
            name="memberships"
            isDisabled={isDisabled}
            selectedItems={selectedData}
            loadData={this.loadData}
            handleChanges={this.handleChanges}
          />
        </div>
      </ControlSection>
    );
  }

  // eslint-disable-next-line react/no-deprecated
  public componentWillReceiveProps(nextProps: IMembershipsProps) {
    if (nextProps.facet.facets !== this.props.facet.facets) {
      this.membershipsFacet = this.mapFacetsToMultiSelectItems(
        nextProps.facet.facets
      );
    }

    if (nextProps.model.memberships !== this.props.model.memberships) {
      this.setState({
        selectedData: nextProps.model.memberships.map((membership) => ({
          name: membership.name,
          value: membership.id,
        })),
      });
    }
  }

  private mapFacetsToMultiSelectItems = (facets: FacetViewModel[]) =>
    facets.map((facet) => ({ name: facet.name, value: facet.id }));

  private handleChanges = (selectedList: IMultiSelectItem<number>[]) => {
    const updatedModel = { ...this.props.model };
    const updatedState = { ...this.state };

    updatedState.isDisabled = selectedList.length >= this.maxActiveCount;
    updatedState.selectedData = selectedList;
    updatedModel.memberships = selectedList.map((item) => ({
      id: item.value,
      name: item.name,
    }));

    this.setState(updatedState, () => this.props.handleChanges(updatedModel));
  };

  private loadData = (value: string) => {
    const result = this.membershipsFacet.filter((item) => {
      const hasMatch =
        item.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
      const hasDuplicate = this.props.model.memberships.some(
        (selectedMembership) => selectedMembership.id === item.value
      );

      return hasMatch && !hasDuplicate;
    });

    return Promise.resolve(result);
  };
}
